import { produce } from 'immer';
import { isLocalhostEnvironment } from '../../utils/utils';
import { CLEAR_ENTRY_SCENE, CLEAR_PENDING_LOGIN_CREDENTIALS, SET_GAME_ENTRY_ACTION_IS_PENDING, SET_LOGIN_STRING, SET_PENDING_LOGIN_CREDENTIALS, SET_SIGN_UP_AGREEMENT_IS_CONFIRMED, SHOW_LOGIN_WINDOW_FROM_INBOUND, SWITCH_TO_LOGIN, SWITCH_TO_SIGN_UP } from '../actions/gameEntryActions';
function getInitialIsSignUpAgreementConfirmed() {
    if (!isLocalhostEnvironment()) {
        return false;
    }
    // localhost
    const params = new URLSearchParams(window.location.search);
    return !params.has('forceSignUpConfirmation');
}
const initialState = {
    entryMode: 'login',
    isActionPending: false,
    isSignUpAgreementConfirmed: getInitialIsSignUpAgreementConfirmed()
};
const gameEntryReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_ENTRY_SCENE: {
                return initialState;
            }
            case SWITCH_TO_SIGN_UP: {
                draft.entryMode = 'sign-up';
                break;
            }
            case SWITCH_TO_LOGIN: {
                draft.entryMode = 'login';
                break;
            }
            case SET_GAME_ENTRY_ACTION_IS_PENDING: {
                draft.isActionPending = action.payload;
                break;
            }
            case SET_LOGIN_STRING: {
                draft.loginString = action.payload;
                break;
            }
            case SHOW_LOGIN_WINDOW_FROM_INBOUND: {
                // TODO: Handle different 'page' strings?
                if (!action.payload.page) {
                    // only if not showing a "page"
                    draft.gameEntryDialogProperties = {
                        title: 'Welcome to Triplejack!',
                        message: action.payload.message,
                        buttons: action.payload.buttons
                    };
                }
                break;
            }
            case SET_SIGN_UP_AGREEMENT_IS_CONFIRMED: {
                draft.isSignUpAgreementConfirmed = true;
                break;
            }
            case SET_PENDING_LOGIN_CREDENTIALS: {
                draft.pendingLoginCredentials = action.payload;
                break;
            }
            case CLEAR_PENDING_LOGIN_CREDENTIALS: {
                delete draft.pendingLoginCredentials;
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default gameEntryReducer;
